<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建课件</el-button>
          <el-button @click="handleBack" plain size="mini">返回上一页</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="课件" prop="wareUrl" align="center">
          <template slot-scope="{row}">
            {{row.wareUrl}} <el-link type="primary" @click="handleDownload(row)">下载</el-link>
          </template>
        </el-table-column>
        <el-table-column label="添加时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedBy" align="center" />
        <el-table-column label="操作" align="center" width="160" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <courseware-add ref="coursewareAdd" @created="doQueryList({})" :rowItem="rowItem" />
  </div>
</template>

<script>
import coursewareAdd from './add'
import courseSubjectWaresApi from '@/api/course/courseSubjectWares'
import Pagination from '@/components/Pagination'

export default {
  props: ['rowItem'],
  components: {
    Pagination,
    coursewareAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.subjectId = this.rowItem.id
      this.listLoading = true
      return courseSubjectWaresApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => courseSubjectWaresApi.deleteBatch({ id: row.id, deleted: true }))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm(`当前选择${this.selectItems.length}条数据，是否确认删除`)
        .then(() => courseSubjectWaresApi.deleteBatch({ id: this.selectItems.map(row => row.id), deleted: true }))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      row.subjectId = this.rowItem.id
      courseSubjectWaresApi.update(row).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    download(href, name) {
      let eleLink = document.createElement('a')
      eleLink.download = name
      eleLink.href = href
      eleLink.click()
      eleLink.remove()
    },
    //下载
    handleDownload(item) {
      if (!item.wareUrl) return
      let type = item.wareUrl.substr(item.wareUrl.lastIndexOf('.') + 1)
      let fileName = item.wareUrl.substr(item.wareUrl.lastIndexOf('/') + 1)
      if (type === 'pdf') {
        fetch(item.wareUrl).then(response => response.blob()).then(blob => {
          // 创建一个临时的URL对象
          const url = URL.createObjectURL(blob);
          // 创建一个隐藏的<a>标签，并设置其href属性为临时URL
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          a.style.display = 'none';
          // 将<a>标签添加到文档中，并模拟点击下载
          document.body.appendChild(a);
          a.click();
          // 下载完成后，移除<a>标签和临时URL对象
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }).catch(error => {
          console.error('下载文件时出错:', error);
        });
      } else {
        let a = document.createElement('a')
        a.href = item.wareUrl
        a.click();
      }
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.coursewareAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.coursewareAdd.handleUpdate(row)
    }
  }
}
</script>
